<template>
  <div>
    <van-popup
      v-model="show"
      position="bottom"
      round
      class="my-popup"
      @close="bindClose"
    >
      <div class="toast-container">
        <div class="vote-container" v-if="voteNum && data">
          <div class="vote-title">为{{ data.c_name }}投票</div>
          <div class="vote-tips">请选择票数</div>
          <div class="operate">
            <span
              class="btn-item less iconfont icon-you"
              @click="bindLess"
            ></span>
            <span class="number">{{ curVoteNum }}</span>
            <span
              class="btn-item add iconfont icon-you"
              @click="bindAdd"
            ></span>
            <span class="btn-item max" @click="bindMax">最大</span>
          </div>
          <div class="total"
            >拥有投票券<span class="vote-num">{{ voteNum }}</span
            >张</div
          >
          <div class="vote-btn" @click="bindVote">确定投票</div>
        </div>
        <div class="not-vote" v-else>
          <img
            class="emoji"
            src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/c810c2a79d16c3004bd811af594eb8a2.png"
            alt=""
          />
          <div class="vote-title">很遗憾...</div>
          <div class="vote-tips">目前没有投票券</div>
          <div class="vote-btn" @click="bindGet">获取投票券</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    voteNum: {
      type: Number,
      default: 0
    },
    data: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      show: false,
      curVoteNum: 1
    }
  },
  watch: {
    value() {
      this.show = this.value
      this.curVoteNum = 1
    }
  },
  created() {
    this.show = this.value
  },
  methods: {
    bindClose() {
      this.$emit('input', false)
    },
    bindLess() {
      if (this.curVoteNum > 1) {
        this.curVoteNum--
      }
    },
    bindAdd() {
      if (this.curVoteNum < this.voteNum) {
        this.curVoteNum++
      }
    },
    bindMax() {
      this.curVoteNum = this.voteNum
    },
    bindVote() {
      this.$emit('vote', this.curVoteNum)
    },
    bindGet() {
      this.$emit('get')
    }
  }
}
</script>
<style lang="scss" scoped>
.toast-container {
  // @include paddingBottom(0px);

  .vote-container {
    padding: 25px 35px 32px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;

    .vote-title {
      font-size: 18px;
      font-family: PingFangSC, PingFang SC;
      font-weight: bold;
      color: rgba(0, 0, 0, 0.8);
      line-height: 25px;
      margin-bottom: 4px;
    }

    .vote-tips {
      font-size: 12px;
      font-family: PingFangSC, PingFang SC;
      color: rgba(0, 0, 0, 0.5);
      line-height: 17px;
      margin-bottom: 12px;
    }

    .operate {
      width: 100%;
      border-top: 1px dashed #dddddd;
      border-bottom: 1px dashed #dddddd;
      padding: 20px 0px;
      margin-bottom: 14px;
      display: flex;
      align-items: center;
      justify-content: flex-end;

      .btn-item {
        height: 40px;
        background: #baa6ff;
        border-radius: 8px;
        line-height: 40px;
        font-size: 14px;
        font-family: PingFangSC, PingFang SC;
        font-weight: bold;
        color: #ffffff;
      }

      .number {
        width: 148px;
        font-size: 32px;
        font-family: PingFangSC, PingFang SC;
        font-weight: bold;
        color: rgba(0, 0, 0, 0.8);
        line-height: 22px;
      }

      .less,
      .add {
        width: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .less {
        transform: rotate(180deg);
      }

      .max {
        width: 44px;
        margin-left: 8px;
      }
    }

    .total {
      font-size: 12px;
      font-family: PingFangSC, PingFang SC;
      color: rgba(0, 0, 0, 0.8);
      line-height: 16px;
      margin-bottom: 8px;

      .vote-num {
        color: rgba(98, 54, 255, 1);
      }
    }

    .vote-btn {
      width: 225px;
      height: 40px;
      line-height: 40px;
      background: linear-gradient(90deg, #c592ff 0%, #6c5aff 100%);
      border-radius: 20px;
      font-size: 16px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      color: #ffffff;
    }
  }

  .not-vote {
    text-align: center;
    padding: 30px 0 40px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .emoji {
      width: 60px;
      height: 60px;
      margin-bottom: 16px;
    }
    .vote-title {
      font-size: 18px;
      font-family: PingFangSC, PingFang SC;
      font-weight: bold;
      color: rgba(0, 0, 0, 0.8);
      line-height: 25px;
      margin-bottom: 4px;
    }

    .vote-tips {
      font-size: 12px;
      font-family: PingFangSC, PingFang SC;
      color: rgba(0, 0, 0, 0.5);
      line-height: 17px;
      margin-bottom: 60px;
    }
    .vote-btn {
      width: 225px;
      height: 40px;
      line-height: 40px;
      background: linear-gradient(90deg, #c592ff 0%, #6c5aff 100%);
      border-radius: 20px;
      font-size: 16px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      color: #ffffff;
    }
  }
}
</style>
